module.exports = __webpack_public_path__ + "media/banners/cuk-banner-84a999fd.png";